  /**
   * Color Variants Grid
   */
  (function() {

    const COLOR_OPTION_NAMES = ['color', 'colour', 'litur', 'färg'];

    function init() {
      processAllCards();
    }

    function processAllCards() {
      const productCards = document.querySelectorAll('.product-card:not([data-color-processed])');

      if (!productCards.length) return;

      productCards.forEach((card, index) => {
        // Stagger requests to avoid rate limiting
        setTimeout(() => processProductCard(card), index * 100);
      });
    }
    
    function updateOriginalQuickBuy(cardElement, product, colorData) {
      const drawer = cardElement.querySelector('quick-buy-drawer[id]');
      if (!drawer) return;

      drawer.setAttribute('handle', `${product.handle}?variant=${colorData.variantId}`);
    }

    function processProductCard(cardElement) {
      if (cardElement.hasAttribute('data-color-processed')) return;
      cardElement.setAttribute('data-color-processed', 'true');

      const productLink = cardElement.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      const productUrl = productLink.getAttribute('href').split('?')[0];

      fetch(productUrl + '.json')
        .then(response => response.json())
        .then(data => {
          const product = data.product;
          const colorOptionIndex = getColorOptionIndex(product.options);

          if (colorOptionIndex === -1) return;

          const colorVariants = getUniqueColorVariants(product.variants, colorOptionIndex);

          if (colorVariants.length <= 1) return;

          // Create duplicate cards for additional colors
          let insertAfter = cardElement;
          colorVariants.slice(1).forEach((colorData) => {
            const clonedCard = createColorCard(cardElement, product, colorData);
            insertAfter.parentNode.insertBefore(clonedCard, insertAfter.nextSibling);
            insertAfter = clonedCard;
          });

          // Update original card with first color
          //addColorLabel(cardElement, colorVariants[0].color);
          updateCardImage(cardElement, product, colorVariants[0]);
          updateCardLink(cardElement, colorVariants[0].variantId);
          updateOriginalQuickBuy(cardElement, product, colorVariants[0]);
        })
        .catch(err => console.log('error'));
    }

    function getColorOptionIndex(options) {
      for (let i = 0; i < options.length; i++) {
        const optionName = options[i].name.toLowerCase();
        if (COLOR_OPTION_NAMES.includes(optionName)) {
          return i;
        }
      }
      return -1;
    }

    function getUniqueColorVariants(variants, colorOptionIndex) {
      const seen = new Map();
      const optionKey = 'option' + (colorOptionIndex + 1);

      variants.forEach(variant => {
        const colorValue = variant[optionKey];
        if (colorValue && !seen.has(colorValue)) {
          seen.set(colorValue, {
            color: colorValue,
            variantId: variant.id,
            price: variant.price,
            compareAtPrice: variant.compare_at_price,
            image: variant.featured_image || null
          });
        }
      });

      return Array.from(seen.values());
    }

    function updateQuickBuyForClone(cardElement, product, colorData) {
      const drawer = cardElement.querySelector('quick-buy-drawer[id]');
      if (!drawer) return;

      const oldId = drawer.id;
      const uniqueSuffix = `${colorData.variantId}`;
      const newId = `${oldId}-variant-${uniqueSuffix}`;

      drawer.id = newId;

      // Point all quick-buy buttons in this cloned card to the new drawer ID
      cardElement.querySelectorAll(`[aria-controls="${oldId}"]`).forEach(button => {
        button.setAttribute('aria-controls', newId);
        button.setAttribute('aria-expanded', 'false');
      });
    
      // Make sure the drawer opens the correct variant
      drawer.setAttribute('handle', `${product.handle}?variant=${colorData.variantId}`);
    
      // Clear any loaded quick-buy content from the cloned drawer
      drawer.innerHTML = '';
    }

    function createColorCard(originalCard, product, colorData) {
      const clone = originalCard.cloneNode(true);

      clone.setAttribute('data-color-variant', colorData.color);
      clone.setAttribute('data-color-processed', 'true');

      updateCardLink(clone, colorData.variantId);
      updateCardImage(clone, product, colorData);
      updateQuickBuyForClone(clone, product, colorData);
      //addColorLabel(clone, colorData.color);

      return clone;
    }

    function updateCardLink(cardElement, variantId) {
      const links = cardElement.querySelectorAll('a[href*="/products/"]');
      links.forEach(link => {
        const baseUrl = link.getAttribute('href').split('?')[0];
        link.setAttribute('href', baseUrl + '?variant=' + variantId);
      });
    }

    function updateCardImage(cardElement, product, colorData) {
      const colorLower = colorData.color.toLowerCase();
      let matchingImage = null;

      if (colorData.image && colorData.image.src) {
        matchingImage = colorData.image.src;
      } else {
        const found = product.images.find(img =>
          img.alt && img.alt.toLowerCase().includes(colorLower)
        );
        if (found) matchingImage = found.src;
      }

      if (matchingImage) {
        const imgs = cardElement.querySelectorAll('img');
        imgs.forEach(img => {
          img.setAttribute('src', matchingImage);
          img.setAttribute('srcset', '');
          img.removeAttribute('data-srcset');
        });
      }
    }

    function addColorLabel(cardElement, colorName) {
      const existingLabel = cardElement.querySelector('.color-variant-label');
      if (existingLabel) {
        existingLabel.textContent = colorName;
        return;
      }

      const label = document.createElement('div');
      label.className = 'color-variant-label';
      label.textContent = colorName;
      label.style.cssText = 'font-size: 0.85em; color: #666; padding: 4px 8px;';

      cardElement.appendChild(label);
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Watch for new products (pagination, infinite scroll, filters)
    const observer = new MutationObserver((mutations) => {
      let hasNewCards = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('product-card') && !node.hasAttribute('data-color-processed')) {
              hasNewCards = true;
            }
            // Also check children
            if (node.querySelectorAll) {
              const newCards = node.querySelectorAll('.product-card:not([data-color-processed])');
              if (newCards.length) hasNewCards = true;
            }
          }
        });
      });

      if (hasNewCards) {
        setTimeout(processAllCards, 200);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Also listen for URL changes (for pagination without full reload)
    let lastUrl = location.href;
    new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        setTimeout(processAllCards, 500);
      }
    }).observe(document, { subtree: true, childList: true });

  })();